
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SE_ICON_MODULE_BUNDLE, SeIconModule } from '../icon/icon.module'
import { SE_BUTTON_MODULE_BUNDLE, SeButtonModule } from '../button/button.module'

import { SeEmptyStateComponent } from './empty-state.component'

@NgModule({
  declarations: [
    SeEmptyStateComponent,
  ],
  exports: [
    SeEmptyStateComponent,
  ],
  imports: [
	CommonModule, 
    SeIconModule,
    SeButtonModule
  ],
})
export class SeEmptyStateModule {}

export const SE_EMPTY_STATE_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.emptyState`

